import React from "react";

const Header = () => {
  return (
    <React.Fragment>
      <header className="es-header es-js-header">
        <div className="es-header-product es-js-product">
          <a aria-label="Productname homepage" href=".">
            <img
              alt="Elsevier"
              className="es-header-product-logo"
              src="/ElsevierStyleSheet/images/nonsolus.svg"
            />
            <img
              alt="Elsevier"
              className="els-logo"
              src="/ElsevierStyleSheet/images/elsevier-wordmark.svg"
            />
          </a>
        </div>
      </header>
    </React.Fragment>
  );
};

export default Header;